import styled from 'styled-components';

import BoxButton, {
  BOX_BUTTON_COLOR,
  BOX_BUTTON_SIZE,
} from '@/components/atom/buttons/BoxButton';

interface Props {
  handleClickRequestButton: () => void;
}

const RequestInfoBox = ({ handleClickRequestButton }: Props) => {
  return (
    <Wrapper>
      <EmptyResultTitle>찾으시는 정보가 없나요?</EmptyResultTitle>
      <EmptyResultOffer>정보를 알려주시면 빠르게 개선할게요</EmptyResultOffer>
      <ButtonSection>
        {/* 싱크업 내용 : 일단 deprecated버튼 사용, 추후에 새로 버튼 컴포넌트 정의될 예정 */}
        <BoxButton
          size={BOX_BUTTON_SIZE.MEDIUM}
          color={BOX_BUTTON_COLOR.SECONDARY}
          onClick={handleClickRequestButton}
        >
          정보 요청하기
        </BoxButton>
      </ButtonSection>
    </Wrapper>
  );
};

export default RequestInfoBox;

const Wrapper = styled.div`
  display: inline-grid;
  width: 100%;
  text-align: center;
  align-items: center;
  padding-top: 40px;
  margin-bottom: 80px;
`;

const EmptyResultTitle = styled.div`
  ${({ theme }) => theme.typography.UI20SB};
  color: ${({ theme }) => theme.color.gray600};
  margin-top: 20px;
`;

const EmptyResultOffer = styled.div`
  ${({ theme }) => theme.typography.UI15R};
  color: ${({ theme }) => theme.color.gray400};
  margin: 8px 0 20px;
`;

const ButtonSection = styled.div`
  justify-content: center;
  display: flex;
`;
